import React from 'react'

export default function Price() {
    return (
        <>
       
        <div id='price'>
            <div  className="prices">
                <div className='container'>
            
             <div className='Common'>
                 
             <h3 className='heading'>Choose a plan</h3>
              <h1 className='main-heading'>pricing plan</h1>
              <p className='main-content'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Nihil, excepturi! Repellat quibusdam adipisci qui vero?</p>
              <div className='commonBorder'></div>
              </div> 
                    <div className="row">
                        <div className="col-4">
                            <div className="price-sec">
                                <div className="price-head">Basic</div>
                                <div className="price-se"><span>$</span>50</div>
                                <ul>
                                    <li>50 gb Stroge space</li>                                    <li>20 gb Monthly b</li>
                                    <li>50 gb Monthly Bandwidth</li>
                                    <li>MySql Database</li>
                                    <li>100 email account</li>
                                    <li>10 free domain name</li>
                                </ul>
                                <div className='price-b'>
                                    <a className='btn btn-outline'>Purches</a>
                                </div>
                            </div>
                        </div>
                    
                    <div className="col-4">
                            <div className="price-sec">
                                <div className="price-head">Standard</div>
                                <div className="price-se"><span>$</span>80</div>
                                <ul>
                                    <li>50 gb Stroge space</li>                                    <li>20 gb Monthly b</li>
                                    <li>50 gb Monthly Bandwidth</li>
                                    <li>MySql Database</li>
                                    <li>100 email account</li>
                                    <li>10 free domain name</li>
                                </ul>
                                <div className='price-b'>
                                    <a className='btn bt btn-outline'>Purches</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="price-sec">
                                <div className="price-head">Premium</div>
                                <div className="price-se"><span>$</span>160</div>
                                <ul>
                                    <li>50 gb Stroge space</li>                                    <li>20 gb Monthly b</li>
                                    <li>50 gb Monthly Bandwidth</li>
                                    <li>MySql Database</li>
                                    <li>100 email account</li>
                                    <li>10 free domain name</li>
                                </ul>
                                <div className='price-b'>
                                    <a className='btn  btn-outline'>Purches</a>
                                </div>
                            </div>
                        </div>
                        </div>
                </div>
            </div>
        </div>
        </>
    )
}
